import { DatePicker } from "@renderbus/ui";
import styled from "styled-components";

export const SearchAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OperationArea = styled.div`
  flex-shrink: 0;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TaskAndFrameDatePickerStyle = styled(DatePicker)`
  .ant-picker-input {
    width: 150px;
  }
  &.ant-picker {
    border: 1px solid var(--topup-recharge-input-border);
    background: #2c2c31 !important;
  }
`;
